import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import FormatOption from './FormatOption';
import { findProductVariant } from 'src/common/utils/product';
import omit from 'lodash/omit';

import './Formats.scss';

const Formats = props => (
  <Row className="formats" colsToRowsOn="mobile">
    {props.formats.map(format => (
      <Col key={format.formatId}>
        <FormatOption
          onFormikSubmit={props.onFormikSubmit}
          prismicFormat={format}
          formatIdentifier={props.values.format_identifier}
          variant={findProductVariant(props.product.variants, {
            ...omit(props.productCustomisation, ['box', 'cover', 'size', 'components']),
            format_identifier: format.formatId
          })}
        />
      </Col>
    ))}
  </Row>
);

Formats.propTypes = {
  formats: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  onFormikSubmit: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  productCustomisation: PropTypes.object.isRequired
};

export default Formats;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Formats/Formats.js